export default __webpack_public_path__ + "static/media/TPE.fe603627.svg";